// import { createBrowserHistory } from 'history'
const history: { history: any } = { history: null };
export default history;